import { NavLink, Outlet } from 'react-router-dom';
import { useI18n } from 'core/i18n/I18nProvider';
import { paths } from 'core/routing/paths';
import { useCompany } from 'features/company/CompanyContext';
import { AppShell, BrandLink, ShellMain } from 'layout/AppShell';
import { LanguageSwitcher } from 'shared/components/LanguageSwitcher';

const COMPANY_NAV = [
  { to: paths.companyPortal, key: 'company.nav.dashboard', end: true },
  { to: paths.companyPortalPlans, key: 'company.nav.plans' },
  { to: paths.companyPurchases, key: 'company.nav.purchases' },
  { to: paths.companyCredits, key: 'company.nav.credits' },
  { to: paths.companyCodes, key: 'company.nav.codes' },
  { to: paths.companyParticipants, key: 'company.nav.participants' },
  { to: paths.companySettings, key: 'company.nav.settings' },
];

export function CompanyLayout() {
  const { t } = useI18n();
  const { company } = useCompany();

  return (
    <AppShell className="dashboard-shell company-shell" compactFooter>
      <header className="site-header">
        <div className="shell-container header-inner">
          <BrandLink to={paths.companyPortal} />
          <div className="header-end">
            <LanguageSwitcher />
            <span className="header-user">{company?.display_name || company?.legal_name}</span>
          </div>
        </div>
      </header>
      <div className="chip-nav-wrap">
        <div className="shell-container">
          <nav className="chip-nav" aria-label={t('company.nav.label')}>
            {COMPANY_NAV.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.end}
                className={({ isActive }) => (isActive ? 'active' : undefined)}
              >
                <span>{t(item.key)}</span>
              </NavLink>
            ))}
          </nav>
        </div>
      </div>
      <div className="shell-container dashboard-body">
        <ShellMain className="dashboard-main">
          <Outlet />
        </ShellMain>
      </div>
    </AppShell>
  );
}
